export default "__VITE_ASSET__157bc6a4__"